module.exports = __webpack_public_path__ + "images/2199c12f978af58abe3eed9ea9b9304d-Product3garage2.0.png";